var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"audio-container"},[_c('audio',{staticClass:"audio-controls",attrs:{"controls":""}},[_c('source',{attrs:{"src":_vm.audiourl}})])])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c74350fa","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/previews/SingleFreeVoice.vue
// module id = 399
// module chunks = 1